export default "$ vue add pwa\n";